import { defineComponent as _defineComponent } from 'vue'
import { mdiCrownOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBadgesTab',
  props: {
    eventsAttended: null
  },
  setup(__props: any) {

const props = __props as {
  eventsAttended?: number | null
};



const badgesList = [
  {
    id: 0,
    count: 1,
    color: '#db97ff',
  },
  {
    id: 1,
    count: 10,
    color: '#ff97d7',
  },
  {
    id: 2,
    count: 40,
    color: '#ffd297',
  },
  {
    id: 3,
    count: 80,
    color: '#97ffdc',
  },
  {
    id: 4,
    count: 100,
    color: '#8c7328',
  },
]

function getOpacity(count: number) {
  if (!props.eventsAttended) return 0.3
  return props.eventsAttended < count ? 0.3 : 1
}

return { __sfc: true,props, badgesList, getOpacity, mdiCrownOutline }
}

})